/**
 * @file Expression.js.
 * @author Sérgio Ferraz Souza <todentro@gmail.com>
 * @copyright Cognatis GeoAnalytics & Big Data Ltda :: 2020
 */

import Request from '../components/http/request'
import Service from './Service'

const defaultJsonHeaders = {
    headers: {
        'Content-Type': 'application/json'
    }
}

/**
 * Expression Management Service
 * @class
 */
class Expression extends Service {
    constructor(options, resource) {
        super(options)
        this.resource = resource
        this.request = new Request({ tag: 'das' })
        // this.request = new Request({environment: 'local', tag: 'das'})
    }



    /**
     * GET DNA FK
     *
     * @async
     * @function deleteCacheTemplate
     * @param {number} envId - The ID of the environment.
     * @param {number} geolevelId - The type of the cache template.
     * @return {Promise<json>} The JSON with the result or error.
     */
    async getDnaFk(envId, geolevelId) {
        return new Promise((resolve, reject) => {
            // Validate required parameters
            if (typeof envId === 'undefined') reject("Esperado o identificador do 'envId'");
            if (typeof geolevelId === 'undefined') reject("Esperado o identificador do 'geolevelId'");

            // Construct the endpoint
            let endPoint = `/expression/dnafk/${envId}/${geolevelId}`;
            let req = new Request({ tag: 'python' })
            req.get(endPoint, defaultJsonHeaders)
                .then(response => resolve(response.data))
                .catch(() => reject)

        });
    }

    async getMultiSelectUrl(environmentId, expressionId) {
        
          try {
            return new Promise((resolve, reject) => {
              // Validate required parameters
              if (typeof environmentId === 'undefined') reject("Esperado o identificador do 'envId'");
              if (typeof expressionId === 'undefined') reject("Esperado o identificador do 'expressionId'");
    
              // Construct the endpoint
              let endPoint = `/expression/cache_url/${environmentId}/${expressionId}`;
              let req = new Request({ tag: 'python' })
              req.get(endPoint, defaultJsonHeaders)
                  .then(response => resolve(response.data))
                  .catch(() => reject)
    
          });
          } catch (error) {
            console.error("Erro inesperado em getMultiSelectUrl:", error);
            throw error; // Lança o erro para ser tratado pelo chamador
            
          }
    
    
    
      }





    /**
     * Retorna o Id da Expressão fazendo um match de parametros na tbExpressionMetadata
     *
     * @async
     * @function getIdExpByMetaData
     * @return {object}  Expressão ALVO
     */
    async getIdExpByMetaData(seletor1, year, metric, familyid, category_1 = null, category_2 = null, category_3 = null, category_4 = null, category_5 = null, category_6 = null, seletor2 = null, seletor3 = null) {
        return new Promise((resolve, reject) => {
            if (typeof seletor1 === 'undefined') reject(new Error('Esperado o identificador do seletor'))
            if (typeof year === 'undefined') reject(new Error('Esperado o identificador do Ano da váriavel'))
            if (typeof metric === 'undefined') reject(new Error('Esperado o identificador da métrica'))
            if (typeof familyid === 'undefined') reject(new Error('Esperado o identificador da Familia do seletor'))

            let model = {
                seletor1: seletor1,
                year: year,
                metric: metric,
                familyid: familyid,
                category_1: category_1,
                category_2: category_2,
                category_3: category_3,
                category_4: category_4,
                category_5: category_5,
                category_6: category_6,
                seletor2: seletor2,
                seletor3: seletor3
            }
            const endPoint = '/api/0.1-a/expressionmetadata/getidexpressionbymetadata'
            this.request.beforeRequest()

            this.request.post(endPoint, model, defaultJsonHeaders)
                .then(res => {
                    if (res.data.length > 1) {
                        console.warn('Esperado apenas 1 Id de Expressão, retornou 2')
                        console.warn('familyId: ' + familyid)
                    }
                    if (res.data.length == 0) {
                        console.error('Esperado Id da Expressão, tabela de metadados não retornou nenhum')
                        console.error('familyId: ' + familyid)
                        reject()
                    }
                    resolve(res.status === 200 ? res.data[0] : null)
                })
                .catch(() => reject())
        })
    }

    /**
     * Collect expressions metadata
     *
     * @async
     * @function getExpressionMetaDataByIdExpression
     * @param {Number} expressionId - Expression Id
     * @return {Promise<json>} The json with expression metadata
     */
    async getExpressionMetaDataByIdExpression(expressionId) {
        return new Promise((resolve, reject) => {
            if (typeof expressionId === 'undefined') reject(new Error('Esperado o identificador da expressão'))
            const endPoint = `/api/0.1-a/expressionmetadata/getmetadatabyexpression/${expressionId}`
            this.request.beforeRequest()
            this.request.get(endPoint, { 'idExpression': expressionId })
                .then(res => resolve(res))
                .catch(() => reject)
        })
    }

    /**
     * Collect expressions dataType
     *
     * @async
     * @function getExpressionDataTypeByIdExpression
     * @param {Number} expressionId - Expression Id
     * @return {Promise<json>} The json with expression
     */
    async getExpressionDataTypeByIdExpression(expressionId) {
        return new Promise((resolve, reject) => {
            if (typeof expressionId === 'undefined') reject(new Error('Esperado o identificador da expressão'))
            const endPoint = `/api/0.1-a/expression/${expressionId}?v1=false`
            this.request.beforeRequest()
            this.request.get(endPoint, { 'idExpression': expressionId })
                .then(res => resolve(res))
                .catch(() => reject)
        })
    }

    /**
     * Collect expressions metadata
     *
     * @async
     * @function getExpressionMetaData
     * @param {Number} expressionId - Expression Id
     * @param {Number} bins - Number of bins
     * @param {Number} method - Distribution method
     * @param {object} model - Model of the metadata
     * @return {Promise<json>} The json with expression metadata
     */
    async
    getExpressionMetaData(expressionId, metric, year, subcategory = '', child = []) {
        return new Promise((resolve, reject) => {
            if (typeof expressionId === 'undefined') reject(new Error('Esperado o identificador da expressão'))
            if (typeof metric === 'undefined') reject(new Error('Esperado a metrica da expressão'))
            if (typeof year === 'undefined') reject(new Error('Esperado o ano da expressão'))
            const endPoint = `/api/0.1-a/expressionmetadata/details`
            this.request.beforeRequest()
            this.request.post(endPoint, {
                'idExpression': expressionId,
                'metric': metric,
                'year': year,
                'subcategory': subcategory,
                'child': child
            })
                .then(res => resolve(res))
                .catch(() => reject)
        })
    }
    /**
     * Calculate bucket to a expression
     *
     * @async
     * @function getBuckets
     * @param {Number} expressionId - Expression Id
     * @param {Number} bins - Number of bins
     * @param {Number} method - Distribution method
     * @param {object} model - Model of the metadata
     * @param {Number} tableSample - Table sample method
     * @param {Number} sizeSample - Table sample size
     * @return {Promise<json>} The json with expression buckets
     */
    async
    getBuckets(expressionId, bins = 3, method = 4, model, tableSample = 0, sizeSample = 0) {
        return new Promise((resolve, reject) => {
            if (typeof expressionId === 'undefined') reject(new Error('Esperado o identificador da expressão'))
            if (typeof model === 'undefined') reject(new Error('Esperado o modelo da expressão'))
            const endPoint = `/api/0.1-a/Expression/buckets/${expressionId}/${bins}/${method}/${tableSample}/${sizeSample}`
            this.request.beforeRequest()
            this.request.post(endPoint, model, defaultJsonHeaders)
                .then(res => resolve(res))
                .catch(() => reject)
        })
    }
    /**
     * Create expression
     *
     * @async
     * @function create
     * @param {object} model - Model of the metadata
     * @return {Promise<json>} The json with expression created
     */
    async
    create(model) {
        return new Promise((resolve, reject) => {
            if (typeof name === 'undefined') reject(new Error('Esperado o nome da expressão'))
            let endPoint = `/api/0.1-a/Expression`
            this.request.post(endPoint, model, defaultJsonHeaders)
                .then(response => resolve(response.data))
                .catch(() => reject)
        })
    }
    /**
     * Decode expression to sql version
     *
     * @async
     * @function decode
     * @param {Number} expressionId - Expression Id
     * @return {Promise<json>} The json with the expression
     */
    async
    decode(expressionId) {
        return new Promise((resolve, reject) => {
            if (typeof expressionId === 'undefined') reject(new Error('Esperado o identificador da expressão'))
            let endPoint = `/api/0.1-a/expression/decode/${expressionId}`
            this.request.get(endPoint, defaultJsonHeaders)
                .then(response => resolve(response))
                .catch(() => reject)
        })
    }
    /**
     * Delete expression
     *
     * @async
     * @function delete
     * @param {Number} expressionId - Expression Id
     * @return {Promise<string>} The data from the URL.
     */
    async
    delete(expressionId) {
        return new Promise((resolve, reject) => {
            if (typeof expressionId === 'undefined') reject(new Error('Esperado o identificador da expressão'))
            let endPoint = `/api/0.1-a/Expression/${expressionId}`
            this.request.delete(endPoint, defaultJsonHeaders)
                .then(response => resolve(response.data))
                .catch(() => reject)
        })
    }

    /**
     * Evaluate expression
     *
     * @async
     * @function evaluate
     * @param {Number} expressionId - Expression Id
     * @return {Promise<string>} The expression evaluated data
     */
    async
    evaluate(expressionId, model) {
        return new Promise((resolve, reject) => {
            if (typeof expressionId === 'undefined') reject(new Error('Esperado o identificador da expressão'))
            if (typeof model === 'undefined') reject(new Error('Esperado o modelo da expressão'))
            const endPoint = `/api/0.1-a/Expression/evaluate/${expressionId}`
            this.request.post(endPoint, model, defaultJsonHeaders)
                .then(res => resolve(res))
                .catch(() => reject)
        })
    }
    /**
     * Evaluate a list of the expression
     *
     * @async
     * @function evaluateList
     * @return {Promise<string>} The expressions evaluated data
     */
    async
    evaluateList(model) {
        return new Promise((resolve, reject) => {
            if (typeof model === 'undefined') reject(new Error('Esperado o modelo da expressão'))
            const endPoint = `/api/0.1-a/Expression/evaluate`
            this.request.post(endPoint, model, defaultJsonHeaders)
                .then(res => resolve(res))
                .catch(() => reject())
        })
    }

    async
    geExpressionIdOptions(id) {
        return new Promise((resolve, reject) => {
            let endPoint = `/api/0.1-a/ProxyPostgRest/api/tbInputFormOption?expressionid=eq.${id}`
            this.request.get(endPoint, defaultJsonHeaders)
                .then(response => resolve(response))
                .catch(() => reject)
        })
    }

    /**
     * Get expressions
     *
     * @async
     * @function getAll
     * @param {object} primitive - Include only primitives
     * @param {Number} skip - Skip rows
     * @param {Number} take - Take rows
     * @return {Promise<json>} The json with the expressions
     */
    async
    getAll(primitive = null, skip = 0, take = 0) {
        return new Promise((resolve, reject) => {
            let endPoint = `/api/0.1-a/Expression?`
            if (primitive !== null) endPoint += `isPrimitive=${primitive}`
            if (skip !== 0) endPoint += `&skip=${skip}`
            if (take !== 0) endPoint += `&take=${take}`
            this.request.get(endPoint, defaultJsonHeaders)
                .then(response => resolve(response))
                .catch(() => reject)
        })
    }
    /**
     * Get expression by id
     *
     * @async
     * @function getById
     * @param {Number} expressionId - Expression Id
     * @return {Promise<json>} The json with the expression
     */
    async
    getById(expressionId, v1 = false) {
        return new Promise((resolve, reject) => {
            if (typeof expressionId === 'undefined') reject(new Error('Esperado o identificador da expressão'))
            let endPoint = `/api/0.1-a/Expression/${expressionId}?v1=${v1}`
            this.request.get(endPoint, defaultJsonHeaders)
                .then(response => resolve(response))
                .catch(() => reject())
        })
    }
    /**
     * Get expression by Name
     *
     * @async
     * @function getByName
     * @param {text} table - table
     * @param {text} field - field
     * @param {number} geolevel - field
     * @param {text} schema - field
     * @return {Promise<json>} The json with the expression
     */
    async
    getByName(table, field, geolevel = 0, schema = 'default') {
        return new Promise((resolve, reject) => {
            let endPoint = `/api/0.1-a/Expression/${table}/${field}/${geolevel}/${schema}`
            this.request.get(endPoint, defaultJsonHeaders)
                .then(response => resolve(response))
                .catch(() => reject)
        })
    }
    /**
     * Get treeview structure
     * @async
     * @function getTreeviewStructure
     * @param {Number} expressionId - The expression id
     * @return {Promise<json>} The json with the layers
     */
    async getTreeviewStructure(expressionId) {
        return new Promise((resolve, reject) => {
            if (typeof expressionId === 'undefined') reject(new Error('Esperado o identificador da expressão'))
            let endPoint = `/api/0.1-a/Expression/getTreeViewStructure/${expressionId}`
            this.request.get(endPoint, defaultJsonHeaders)
                .then(res => {
                    if (res.status === 200) {
                        const result = res.data.value
                        if (result.length > 0)
                            resolve(result)
                        else
                            reject(res)
                    } else {
                        reject(res)
                    }
                })
                .catch(() => reject)
        })
    }
    /**
     * Update expression
     *
     * @async
     * @function update
     * @param {object} model - Model of the metadata
     * @return {Promise<json>} The json with expression updated
     */
    async
    update(model) {
        return new Promise((resolve, reject) => {
            if (typeof model === 'undefined') reject(new Error('Esperado o modelo da expressão'))
            let endPoint = `/api/0.1-a/Expression`
            this.request.put(endPoint, model, defaultJsonHeaders)
                .then(response => resolve(response.data))
                .catch(() => reject)
        })
    }

    /**
     * Get expression Topn
     *
     * @async
     * @function getByTopn
     * @param {Number} expressionId - Expression Id
     * @param {Number} limit - Number of bins
     * @param {Number} filter - Filter Layer Oid
     * @param {Boolean} allowNulls - Allow null or empty values
     * @return {Promise<json>} The json with the body {metrics: -1, data: {}}
     */
    async
    getByTopn(expressionId, limit, filter = 0, allowNulls= true) {
        return new Promise((resolve, reject) => {
            const endPoint = `/api/0.1-a/Expression/topn/${expressionId}?limit=${limit}&filter=${filter}&allowNulls=${allowNulls}`
            this.request.get(endPoint, defaultJsonHeaders)
                .then(res => {
                    if (res.status >= 200 && res.status < 300) {
                        const result = {universe: res.data.universe, data: res.data.rows}
                        resolve(result)
                    } else {
                        const message = res.data.message || res.data.msg || 'Erro ao calcular o TopN'
                        console.log(res.data)
                        reject(new Error(message))
                    }
                })
                .catch(() => reject)
        })
    }
    /**
     * Get statistical types
     *
     * @async
     * @function getStatisticalTypes
     * @return {Promise<json>} The json with the types
     */
    async
    getStatisticalTypes() {
        return new Promise((resolve, reject) => {
            let endPoint = `/api/0.1-a/expression/statisticaltypes`
            this.request.get(endPoint, defaultJsonHeaders)
                .then(response => resolve(response))
                .catch(() => reject)
        })
    }
}

export { Expression }
